import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=a363defc&scoped=true&"
import script from "./LocationList.vue?vue&type=script&lang=js&"
export * from "./LocationList.vue?vue&type=script&lang=js&"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=a363defc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a363defc",
  null
  
)

export default component.exports